module.exports = __webpack_public_path__ + "static/media/stofferingen-11.ecb79b8b.jpg";